import React from 'react';
import { UserProfile } from '../../../types/types';
import { AppSyncUser } from '../../../services/auth/types/user';
import Avatar from '../../../components/shared/Avatar/Avatar';
import Calendar from '../../../components/shared/Calendar/Calendar';
import './RightPanel.css';

interface RightPanelProps {
  user: UserProfile;
  appSyncUser: AppSyncUser | null;
}

const RightPanel: React.FC<RightPanelProps> = ({ user, appSyncUser }) => {
  // Display name: nickname first, then firstName, then fallback (all from AppSync)
  const displayName = appSyncUser?.nickname || 
                      appSyncUser?.firstName || 
                      user?.name || 
                      'User';
  
  // Get picture from AppSync (all user data comes from AppSync, not Cognito)
  const userPicture = appSyncUser?.picture_url || appSyncUser?.avatarUrl || user?.avatar || undefined;

  const suggestions = [
    { id: 1, name: 'Alex Thompson', avatar: '👨‍💻', followers: '2.1k', mutual: 5 },
    { id: 2, name: 'Maria Garcia', avatar: '👩‍🎨', followers: '1.8k', mutual: 3 },
    { id: 3, name: 'David Kim', avatar: '👨‍🔬', followers: '3.2k', mutual: 8 }
  ];

  const destinations = [
    { id: 1, name: 'Bali Adventure', image: '🏝️', color: '#10b981' },
    { id: 2, name: 'Paris Discovery', image: '🗼', color: '#818cf8' }
  ];

  return (
    <div className="right-panel">
      {/* User Info Block */}
      <div className="user-info-block">
        <div className="user-avatar-wrapper">
          <Avatar 
            src={userPicture}
            alt="User Avatar"
            size="large"
          />
        </div>
        <div className="user-info-content">
          <h3 className="user-name-title">{displayName}</h3>
          <div className="user-stats">
            <span className="stat-text">245 Followers</span>
            <span className="stat-text">189 Following</span>
          </div>
        </div>
      </div>

      {/* People Suggestions */}
      <div className="suggestions-block">
        <h4>People You May Know</h4>
        <div className="suggestions-list">
          {suggestions.slice(0, 2).map(person => (
            <div key={person.id} className="suggestion-item">
              <Avatar 
                src={person.avatar}
                alt={person.name}
                size="medium"
                className="suggestion-avatar"
              />
              <div className="suggestion-info">
                <h5>{person.name}</h5>
                <p>{person.followers} followers</p>
              </div>
              <button className="follow-btn">Follow</button>
            </div>
          ))}
        </div>
      </div>

      {/* Trips Recommendations */}
      <div className="recommendations-block">
        <h4>Trips You Might Love</h4>
        <div className="destinations-grid">
          {destinations.map(destination => (
            <div 
              key={destination.id} 
              className="destination-card"
              style={{ backgroundColor: destination.color }}
            >
              <div className="destination-icon">{destination.image}</div>
              <span className="destination-name">{destination.name}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Calendar */}
      <div className="calendar-block">
        <Calendar />
      </div>
    </div>
  );
};

export default RightPanel;
